const initialState = {
    isLoading: false,
    hasError: false,
    stores: null
}

export default (state = initialState, action) => {
	switch (action.type){
        case 'STORES_ARE_LOADING':
            return {
                ...state,
                isLoading: true
            }
        case 'STORES_HAS_ERROR':
            return {
                ...state,
                isLoading: false,
                hasError: true,
                error: action.error
            }
        case 'STORES_SUCCESS':
            return {
                ...state,
                ...action.payload.data,
                isLoading: false
            }
        case 'RESET_STORES':
            return {
                ...initialState
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/storeLocation.js